import "./AboutUs.css";

function AboutUs() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About Us</h1>
        <p>Your trusted bike rental partner</p>
      </div>

      <div className="about-content">
        <section>
          <h2>Who We Are</h2>
          <p>
            We are a modern bike rental service focused on providing reliable,
            affordable, and well-maintained bikes for your daily commute,
            travel, and adventure needs.
          </p>
        </section>

        <section>
          <h2>Our Mission</h2>
          <p>
            To make bike rentals simple, transparent, and accessible for
            everyone — with clear pricing, easy booking, and excellent support.
          </p>
        </section>

        <section>
          <h2>Why Choose Us?</h2>
          <ul>
            <li>✔ Well-maintained bikes</li>
            <li>✔ Transparent pricing</li>
            <li>✔ Easy online booking</li>
            <li>✔ Customer-first support</li>
            <li>✔ Trusted by local riders</li>
          </ul>
        </section>

        <section>
          <h2>Our Shop</h2>
          <p>
            We currently operate from a single, fully-equipped rental shop with
            plans to expand soon. Visit us anytime or reach out for assistance.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutUs;
